import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Navigation from '../components/Navigation';
import '../styles/global.scss';

const MainLayout: React.FC = () => {
  return (
    <div className="main-layout">
      <Navigation />
      <main className="content">
        <Container fluid>
          <Outlet />
        </Container>
      </main>
      <footer className="footer">
        <Container fluid className="text-center">
          <span className="text-muted">
            © {new Date().getFullYear()} Fluent Insight. All rights reserved.
          </span>
        </Container>
      </footer>
    </div>
  );
};

export default MainLayout; 